import getDistance from './get-distance'
import { UNITS } from '../constants'

export default function getClosestLocation(locations, yourLoc, defaultLocationName, units) {
  if (!locations || locations.length === 0) return null
  if (!yourLoc || yourLoc.lat === undefined || yourLoc.lng === undefined) {
    if (!!defaultLocationName) {
      let defaultLocation = locations.find((loc) => loc.value == defaultLocationName)
      if (!!defaultLocation) {
        window.console.log(
          'defaulting to location with defaultLocationName of',
          defaultLocationName,
        )
        return defaultLocation
      }
    }
    return null
  }

  let yourDistanceUnits = units !== undefined && units !== null ? units : UNITS.MILES
  let yourLocationKey =
    yourLoc.lat.toString() + ',' + yourLoc.lng.toString() + ':' + yourDistanceUnits

  locations.forEach((loc) => {
    loc.yourLocationKey = yourLocationKey
    loc.yourDistanceUnits = yourDistanceUnits
    loc.distanceFromYourLocationKey = getDistance(yourLoc, loc, yourDistanceUnits)
  })

  let closest = locations.reduce((prev, curr) =>
    prev.distanceFromYourLocationKey < curr.distanceFromYourLocationKey ? prev : curr,
  )

  window.console.log('closest location was determined to be', closest)

  return closest
}
